<template lang="pug">
div.body-lo
  div.modal-header
    span.lo-modal-title TẠO PC THÀNH CÔNG
    span.lo-modal-btn-close.material-icons(@click="redirectPC") close
  div.modal-body
    div.reg-content Xin chúc mừng! Bạn đã tạo thành công cộng đồng 
      span “{{pc_name}}”.
    div.note Bắt đầu chia sẻ kiến thức bằng cách cập nhật thông tin Lý Thuyết và Bài Tập cho cộng đồng và lớp học của bạn.
  div.modal-footer.lo-custom-footer
    div.row
      div.col-md-12.col-12.text-center
        a.lo-btn-continue.lo-popup-pc.btn(@click='validateContinute()') Tiếp tục
</template>
<script>
export default {
  props: {
    pc_name: {
      type: String,
      default: ''
    }
  },
  methods: {
    validateContinute() {
      this.$emit('close')
      this.$router.push({name: 'Lesson'})
    },
    redirectPC() {
      this.$emit('close')
      this.$router.push({name: 'general'})
    }
  }
}
</script>
<style lang="scss">
:root {
  // Color 
  --color-background-button: #FFD311;
}
.body-lo {
  margin-left: 5px;
  margin-right: 5px;
  background-color: white;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px;
  .lo-modal-title {
    font-family: 'adobe-clean', sans-serif;
    float: left;
    font-size: 17px;
  }
  .lo-modal-btn-close {
    float: right;
    &:hover {
      cursor: pointer;
    }
  }
  .reg-content{
      span{color: #333333; font-size: 15px; font-weight: bold;}
  }
  .note{margin-top: 20px;}
  .lo-body-title {
    color: var(--color-type-selected);
    margin-bottom: 0;
    padding-bottom: 3px;
  }
  .lo-btn-continue {
    background: var(--color-background-button);
    color: #000;
    text-transform: none;
    font-size: 13px;
    font-family: 'adobe-clean', sans-serif;
    border: 1px solid #FFD311;
    border-radius: 5px;
    // box-shadow: 0px 0px 0px;
    width: 160px;
    margin-top: 0 !important;
    margin-bottom: 15px;
  }
  .lo-popup-pc{color: #23180A; font-size: 14px;}
  .lo-btn-back {
    background: white;
    color: black;
    text-transform: none;
    font-size: 13px;
    font-family: 'adobe-clean', sans-serif;
    border: 1px solid #FFD311;
    border-radius: 5px;
    // box-shadow: 0px 0px 0px;
    width: 160px;
    margin-top: 0 !important;
  }
  .lo-custom-footer {
    padding: 0;
    border: 0;
  }
// cellphones 
@media (max-width: 414px) {
  .lo-btn-continue {
    float: left;
    margin-left: 40px;
    width: 115px;
  }
  .lo-btn-back {
    float: right;
    margin-right: 40px;
    width: 115px;
  }
}
}
</style>



// WEBPACK FOOTER //
// popup.vue?c7a1451c